import { AGENT_LABEL, type AgentKind } from "../models";

const AGENTS: AgentKind[] = ["claude", "codex", "gemini"];

interface Props {
  value: AgentKind;
  onChange: (agent: AgentKind) => void;
  disabled?: boolean;
  /** Motores que a pessoa tem permissão de usar (controlado pelo admin). Default: só Claude. */
  allowed?: AgentKind[];
  /** Disponibilidade REAL por motor (credencial conectada na instância). */
  availability?: Partial<Record<AgentKind, boolean>>;
}

/**
 * Seletor de motor/CLI (Claude, Codex ou Gemini) da conversa. Claude é o
 * default de toda instância; Codex/Gemini só aparecem se a pessoa tiver
 * permissão E a instância tiver credenciais configuradas (o backend já filtra
 * `allowed` levando isso em conta).
 */
export function AgentSelector({ value, onChange, disabled, allowed, availability }: Props) {
  // PADRÃO do produto: TODOS os motores aparecem na lista; os não conectados
  // (sem credencial na instância) ou sem permissão ficam visíveis porém
  // DESABILITADOS - nada de motor sumindo da lista.
  const canUse = (a: AgentKind): boolean => {
    const permitted = allowed?.length ? allowed.includes(a) : a === "claude";
    const available = availability?.[a] !== false; // ausente = assume disponível
    return permitted && available;
  };
  const usable = AGENTS.filter(canUse);
  return (
    <label className="agent-selector" title="Motor de IA usado nas próximas respostas desta conversa">
      <svg width="13" height="13" viewBox="0 0 16 16" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
        <circle cx="8" cy="8" r="6" />
        <path d="M8 5v3l2 2" />
      </svg>
      <select
        value={value}
        onChange={(e) => onChange(e.target.value as AgentKind)}
        disabled={disabled || usable.length <= 1}
        aria-label="Motor"
      >
        {AGENTS.map((a) => {
          const ok = canUse(a);
          const motivo =
            availability?.[a] === false ? " (não conectado)" : !ok ? " (sem permissão)" : "";
          return (
            <option key={a} value={a} disabled={!ok}>
              {AGENT_LABEL[a]}
              {motivo}
            </option>
          );
        })}
      </select>
    </label>
  );
}
